// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.0
//   protoc               v3.21.12
// source: getcases.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "./google/protobuf/timestamp";
import {
  CancerType,
  cancerTypeFromJSON,
  cancerTypeToJSON,
  CaseStatus,
  caseStatusFromJSON,
  caseStatusToJSON,
  Reasoning,
  reasoningFromJSON,
  reasoningToJSON,
  Verbosity,
  verbosityFromJSON,
  verbosityToJSON,
} from "./schema";

export const protobufPackage = "login";

export interface GetCasesRequest {
  offset: number;
  pageSize: number;
  searchQuery?: string | undefined;
  hideInternal?: boolean | undefined;
}

export interface Case {
  id: string;
  providerId: string;
  providerName?: string | undefined;
  cancerType: CancerType;
  submitTime: Date | undefined;
  intakeDataLink: string;
  aiJobStartTime?: Date | undefined;
  aiJobEndTime?: Date | undefined;
  claimedById?: string | undefined;
  claimTime?: Date | undefined;
  completeTime?: Date | undefined;
  status: CaseStatus;
  updatedAt: Date | undefined;
  surveyResponse?: number | undefined;
  surveyComment?: string | undefined;
  verbosity?: Verbosity | undefined;
  reasoning?: Reasoning | undefined;
  finalModel?: string | undefined;
  humanAdjudicationId?: string | undefined;
  aiAdjudicationId?: string | undefined;
  humanAdjudicationSourceModelVersion?: string | undefined;
  aiAdjudicationSourceModelVersion?: string | undefined;
  humanAdjudicationSourceModel?: string | undefined;
  aiAdjudicationSourceModel?: string | undefined;
  assignedReviewerId?: string | undefined;
  assignedReviewerName?: string | undefined;
}

export interface GetCasesResponse {
  cases: Case[];
  totalCount: number;
}

function createBaseGetCasesRequest(): GetCasesRequest {
  return { offset: 0, pageSize: 0, searchQuery: undefined, hideInternal: undefined };
}

export const GetCasesRequest: MessageFns<GetCasesRequest> = {
  encode(message: GetCasesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.offset !== 0) {
      writer.uint32(8).int64(message.offset);
    }
    if (message.pageSize !== 0) {
      writer.uint32(16).int64(message.pageSize);
    }
    if (message.searchQuery !== undefined) {
      writer.uint32(26).string(message.searchQuery);
    }
    if (message.hideInternal !== undefined) {
      writer.uint32(32).bool(message.hideInternal);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCasesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCasesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.offset = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.pageSize = longToNumber(reader.int64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.searchQuery = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.hideInternal = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCasesRequest {
    return {
      offset: isSet(object.offset) ? globalThis.Number(object.offset) : 0,
      pageSize: isSet(object.pageSize)
        ? globalThis.Number(object.pageSize)
        : isSet(object.page_size)
        ? globalThis.Number(object.page_size)
        : 0,
      searchQuery: isSet(object.searchQuery)
        ? globalThis.String(object.searchQuery)
        : isSet(object.search_query)
        ? globalThis.String(object.search_query)
        : undefined,
      hideInternal: isSet(object.hideInternal)
        ? globalThis.Boolean(object.hideInternal)
        : isSet(object.hide_internal)
        ? globalThis.Boolean(object.hide_internal)
        : undefined,
    };
  },

  toJSON(message: GetCasesRequest): unknown {
    const obj: any = {};
    if (message.offset !== 0) {
      obj.offset = Math.round(message.offset);
    }
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.searchQuery !== undefined) {
      obj.searchQuery = message.searchQuery;
    }
    if (message.hideInternal !== undefined) {
      obj.hideInternal = message.hideInternal;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCasesRequest>, I>>(base?: I): GetCasesRequest {
    return GetCasesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCasesRequest>, I>>(object: I): GetCasesRequest {
    const message = createBaseGetCasesRequest();
    message.offset = object.offset ?? 0;
    message.pageSize = object.pageSize ?? 0;
    message.searchQuery = object.searchQuery ?? undefined;
    message.hideInternal = object.hideInternal ?? undefined;
    return message;
  },
};

function createBaseCase(): Case {
  return {
    id: "",
    providerId: "",
    providerName: undefined,
    cancerType: 0,
    submitTime: undefined,
    intakeDataLink: "",
    aiJobStartTime: undefined,
    aiJobEndTime: undefined,
    claimedById: undefined,
    claimTime: undefined,
    completeTime: undefined,
    status: 0,
    updatedAt: undefined,
    surveyResponse: undefined,
    surveyComment: undefined,
    verbosity: undefined,
    reasoning: undefined,
    finalModel: undefined,
    humanAdjudicationId: undefined,
    aiAdjudicationId: undefined,
    humanAdjudicationSourceModelVersion: undefined,
    aiAdjudicationSourceModelVersion: undefined,
    humanAdjudicationSourceModel: undefined,
    aiAdjudicationSourceModel: undefined,
    assignedReviewerId: undefined,
    assignedReviewerName: undefined,
  };
}

export const Case: MessageFns<Case> = {
  encode(message: Case, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.providerId !== "") {
      writer.uint32(18).string(message.providerId);
    }
    if (message.providerName !== undefined) {
      writer.uint32(146).string(message.providerName);
    }
    if (message.cancerType !== 0) {
      writer.uint32(24).int32(message.cancerType);
    }
    if (message.submitTime !== undefined) {
      Timestamp.encode(toTimestamp(message.submitTime), writer.uint32(34).fork()).join();
    }
    if (message.intakeDataLink !== "") {
      writer.uint32(42).string(message.intakeDataLink);
    }
    if (message.aiJobStartTime !== undefined) {
      Timestamp.encode(toTimestamp(message.aiJobStartTime), writer.uint32(50).fork()).join();
    }
    if (message.aiJobEndTime !== undefined) {
      Timestamp.encode(toTimestamp(message.aiJobEndTime), writer.uint32(58).fork()).join();
    }
    if (message.claimedById !== undefined) {
      writer.uint32(66).string(message.claimedById);
    }
    if (message.claimTime !== undefined) {
      Timestamp.encode(toTimestamp(message.claimTime), writer.uint32(74).fork()).join();
    }
    if (message.completeTime !== undefined) {
      Timestamp.encode(toTimestamp(message.completeTime), writer.uint32(82).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(88).int32(message.status);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(98).fork()).join();
    }
    if (message.surveyResponse !== undefined) {
      writer.uint32(104).int32(message.surveyResponse);
    }
    if (message.surveyComment !== undefined) {
      writer.uint32(114).string(message.surveyComment);
    }
    if (message.verbosity !== undefined) {
      writer.uint32(120).int32(message.verbosity);
    }
    if (message.reasoning !== undefined) {
      writer.uint32(128).int32(message.reasoning);
    }
    if (message.finalModel !== undefined) {
      writer.uint32(138).string(message.finalModel);
    }
    if (message.humanAdjudicationId !== undefined) {
      writer.uint32(154).string(message.humanAdjudicationId);
    }
    if (message.aiAdjudicationId !== undefined) {
      writer.uint32(162).string(message.aiAdjudicationId);
    }
    if (message.humanAdjudicationSourceModelVersion !== undefined) {
      writer.uint32(170).string(message.humanAdjudicationSourceModelVersion);
    }
    if (message.aiAdjudicationSourceModelVersion !== undefined) {
      writer.uint32(178).string(message.aiAdjudicationSourceModelVersion);
    }
    if (message.humanAdjudicationSourceModel !== undefined) {
      writer.uint32(186).string(message.humanAdjudicationSourceModel);
    }
    if (message.aiAdjudicationSourceModel !== undefined) {
      writer.uint32(194).string(message.aiAdjudicationSourceModel);
    }
    if (message.assignedReviewerId !== undefined) {
      writer.uint32(202).string(message.assignedReviewerId);
    }
    if (message.assignedReviewerName !== undefined) {
      writer.uint32(210).string(message.assignedReviewerName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Case {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCase();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.providerId = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.providerName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.cancerType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.submitTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.intakeDataLink = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.aiJobStartTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.aiJobEndTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.claimedById = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.claimTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.completeTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.surveyResponse = reader.int32();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.surveyComment = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.verbosity = reader.int32() as any;
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.reasoning = reader.int32() as any;
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.finalModel = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.humanAdjudicationId = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.aiAdjudicationId = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.humanAdjudicationSourceModelVersion = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.aiAdjudicationSourceModelVersion = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.humanAdjudicationSourceModel = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.aiAdjudicationSourceModel = reader.string();
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.assignedReviewerId = reader.string();
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.assignedReviewerName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Case {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      providerId: isSet(object.providerId)
        ? globalThis.String(object.providerId)
        : isSet(object.provider_id)
        ? globalThis.String(object.provider_id)
        : "",
      providerName: isSet(object.providerName)
        ? globalThis.String(object.providerName)
        : isSet(object.provider_name)
        ? globalThis.String(object.provider_name)
        : undefined,
      cancerType: isSet(object.cancerType)
        ? cancerTypeFromJSON(object.cancerType)
        : isSet(object.cancer_type)
        ? cancerTypeFromJSON(object.cancer_type)
        : 0,
      submitTime: isSet(object.submitTime)
        ? fromJsonTimestamp(object.submitTime)
        : isSet(object.submit_time)
        ? fromJsonTimestamp(object.submit_time)
        : undefined,
      intakeDataLink: isSet(object.intakeDataLink)
        ? globalThis.String(object.intakeDataLink)
        : isSet(object.intake_data_link)
        ? globalThis.String(object.intake_data_link)
        : "",
      aiJobStartTime: isSet(object.aiJobStartTime)
        ? fromJsonTimestamp(object.aiJobStartTime)
        : isSet(object.ai_job_start_time)
        ? fromJsonTimestamp(object.ai_job_start_time)
        : undefined,
      aiJobEndTime: isSet(object.aiJobEndTime)
        ? fromJsonTimestamp(object.aiJobEndTime)
        : isSet(object.ai_job_end_time)
        ? fromJsonTimestamp(object.ai_job_end_time)
        : undefined,
      claimedById: isSet(object.claimedById)
        ? globalThis.String(object.claimedById)
        : isSet(object.claimed_by_id)
        ? globalThis.String(object.claimed_by_id)
        : undefined,
      claimTime: isSet(object.claimTime)
        ? fromJsonTimestamp(object.claimTime)
        : isSet(object.claim_time)
        ? fromJsonTimestamp(object.claim_time)
        : undefined,
      completeTime: isSet(object.completeTime)
        ? fromJsonTimestamp(object.completeTime)
        : isSet(object.complete_time)
        ? fromJsonTimestamp(object.complete_time)
        : undefined,
      status: isSet(object.status) ? caseStatusFromJSON(object.status) : 0,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      surveyResponse: isSet(object.surveyResponse)
        ? globalThis.Number(object.surveyResponse)
        : isSet(object.survey_response)
        ? globalThis.Number(object.survey_response)
        : undefined,
      surveyComment: isSet(object.surveyComment)
        ? globalThis.String(object.surveyComment)
        : isSet(object.survey_comment)
        ? globalThis.String(object.survey_comment)
        : undefined,
      verbosity: isSet(object.verbosity) ? verbosityFromJSON(object.verbosity) : undefined,
      reasoning: isSet(object.reasoning) ? reasoningFromJSON(object.reasoning) : undefined,
      finalModel: isSet(object.finalModel)
        ? globalThis.String(object.finalModel)
        : isSet(object.final_model)
        ? globalThis.String(object.final_model)
        : undefined,
      humanAdjudicationId: isSet(object.humanAdjudicationId)
        ? globalThis.String(object.humanAdjudicationId)
        : isSet(object.human_adjudication_id)
        ? globalThis.String(object.human_adjudication_id)
        : undefined,
      aiAdjudicationId: isSet(object.aiAdjudicationId)
        ? globalThis.String(object.aiAdjudicationId)
        : isSet(object.ai_adjudication_id)
        ? globalThis.String(object.ai_adjudication_id)
        : undefined,
      humanAdjudicationSourceModelVersion: isSet(object.humanAdjudicationSourceModelVersion)
        ? globalThis.String(object.humanAdjudicationSourceModelVersion)
        : isSet(object.human_adjudication_source_model_version)
        ? globalThis.String(object.human_adjudication_source_model_version)
        : undefined,
      aiAdjudicationSourceModelVersion: isSet(object.aiAdjudicationSourceModelVersion)
        ? globalThis.String(object.aiAdjudicationSourceModelVersion)
        : isSet(object.ai_adjudication_source_model_version)
        ? globalThis.String(object.ai_adjudication_source_model_version)
        : undefined,
      humanAdjudicationSourceModel: isSet(object.humanAdjudicationSourceModel)
        ? globalThis.String(object.humanAdjudicationSourceModel)
        : isSet(object.human_adjudication_source_model)
        ? globalThis.String(object.human_adjudication_source_model)
        : undefined,
      aiAdjudicationSourceModel: isSet(object.aiAdjudicationSourceModel)
        ? globalThis.String(object.aiAdjudicationSourceModel)
        : isSet(object.ai_adjudication_source_model)
        ? globalThis.String(object.ai_adjudication_source_model)
        : undefined,
      assignedReviewerId: isSet(object.assignedReviewerId)
        ? globalThis.String(object.assignedReviewerId)
        : isSet(object.assigned_reviewer_id)
        ? globalThis.String(object.assigned_reviewer_id)
        : undefined,
      assignedReviewerName: isSet(object.assignedReviewerName)
        ? globalThis.String(object.assignedReviewerName)
        : isSet(object.assigned_reviewer_name)
        ? globalThis.String(object.assigned_reviewer_name)
        : undefined,
    };
  },

  toJSON(message: Case): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.providerId !== "") {
      obj.providerId = message.providerId;
    }
    if (message.providerName !== undefined) {
      obj.providerName = message.providerName;
    }
    if (message.cancerType !== 0) {
      obj.cancerType = cancerTypeToJSON(message.cancerType);
    }
    if (message.submitTime !== undefined) {
      obj.submitTime = message.submitTime.toISOString();
    }
    if (message.intakeDataLink !== "") {
      obj.intakeDataLink = message.intakeDataLink;
    }
    if (message.aiJobStartTime !== undefined) {
      obj.aiJobStartTime = message.aiJobStartTime.toISOString();
    }
    if (message.aiJobEndTime !== undefined) {
      obj.aiJobEndTime = message.aiJobEndTime.toISOString();
    }
    if (message.claimedById !== undefined) {
      obj.claimedById = message.claimedById;
    }
    if (message.claimTime !== undefined) {
      obj.claimTime = message.claimTime.toISOString();
    }
    if (message.completeTime !== undefined) {
      obj.completeTime = message.completeTime.toISOString();
    }
    if (message.status !== 0) {
      obj.status = caseStatusToJSON(message.status);
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.surveyResponse !== undefined) {
      obj.surveyResponse = Math.round(message.surveyResponse);
    }
    if (message.surveyComment !== undefined) {
      obj.surveyComment = message.surveyComment;
    }
    if (message.verbosity !== undefined) {
      obj.verbosity = verbosityToJSON(message.verbosity);
    }
    if (message.reasoning !== undefined) {
      obj.reasoning = reasoningToJSON(message.reasoning);
    }
    if (message.finalModel !== undefined) {
      obj.finalModel = message.finalModel;
    }
    if (message.humanAdjudicationId !== undefined) {
      obj.humanAdjudicationId = message.humanAdjudicationId;
    }
    if (message.aiAdjudicationId !== undefined) {
      obj.aiAdjudicationId = message.aiAdjudicationId;
    }
    if (message.humanAdjudicationSourceModelVersion !== undefined) {
      obj.humanAdjudicationSourceModelVersion = message.humanAdjudicationSourceModelVersion;
    }
    if (message.aiAdjudicationSourceModelVersion !== undefined) {
      obj.aiAdjudicationSourceModelVersion = message.aiAdjudicationSourceModelVersion;
    }
    if (message.humanAdjudicationSourceModel !== undefined) {
      obj.humanAdjudicationSourceModel = message.humanAdjudicationSourceModel;
    }
    if (message.aiAdjudicationSourceModel !== undefined) {
      obj.aiAdjudicationSourceModel = message.aiAdjudicationSourceModel;
    }
    if (message.assignedReviewerId !== undefined) {
      obj.assignedReviewerId = message.assignedReviewerId;
    }
    if (message.assignedReviewerName !== undefined) {
      obj.assignedReviewerName = message.assignedReviewerName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Case>, I>>(base?: I): Case {
    return Case.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Case>, I>>(object: I): Case {
    const message = createBaseCase();
    message.id = object.id ?? "";
    message.providerId = object.providerId ?? "";
    message.providerName = object.providerName ?? undefined;
    message.cancerType = object.cancerType ?? 0;
    message.submitTime = object.submitTime ?? undefined;
    message.intakeDataLink = object.intakeDataLink ?? "";
    message.aiJobStartTime = object.aiJobStartTime ?? undefined;
    message.aiJobEndTime = object.aiJobEndTime ?? undefined;
    message.claimedById = object.claimedById ?? undefined;
    message.claimTime = object.claimTime ?? undefined;
    message.completeTime = object.completeTime ?? undefined;
    message.status = object.status ?? 0;
    message.updatedAt = object.updatedAt ?? undefined;
    message.surveyResponse = object.surveyResponse ?? undefined;
    message.surveyComment = object.surveyComment ?? undefined;
    message.verbosity = object.verbosity ?? undefined;
    message.reasoning = object.reasoning ?? undefined;
    message.finalModel = object.finalModel ?? undefined;
    message.humanAdjudicationId = object.humanAdjudicationId ?? undefined;
    message.aiAdjudicationId = object.aiAdjudicationId ?? undefined;
    message.humanAdjudicationSourceModelVersion = object.humanAdjudicationSourceModelVersion ?? undefined;
    message.aiAdjudicationSourceModelVersion = object.aiAdjudicationSourceModelVersion ?? undefined;
    message.humanAdjudicationSourceModel = object.humanAdjudicationSourceModel ?? undefined;
    message.aiAdjudicationSourceModel = object.aiAdjudicationSourceModel ?? undefined;
    message.assignedReviewerId = object.assignedReviewerId ?? undefined;
    message.assignedReviewerName = object.assignedReviewerName ?? undefined;
    return message;
  },
};

function createBaseGetCasesResponse(): GetCasesResponse {
  return { cases: [], totalCount: 0 };
}

export const GetCasesResponse: MessageFns<GetCasesResponse> = {
  encode(message: GetCasesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.cases) {
      Case.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.totalCount !== 0) {
      writer.uint32(16).int64(message.totalCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCasesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCasesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.cases.push(Case.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.totalCount = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCasesResponse {
    return {
      cases: globalThis.Array.isArray(object?.cases) ? object.cases.map((e: any) => Case.fromJSON(e)) : [],
      totalCount: isSet(object.totalCount)
        ? globalThis.Number(object.totalCount)
        : isSet(object.total_count)
        ? globalThis.Number(object.total_count)
        : 0,
    };
  },

  toJSON(message: GetCasesResponse): unknown {
    const obj: any = {};
    if (message.cases?.length) {
      obj.cases = message.cases.map((e) => Case.toJSON(e));
    }
    if (message.totalCount !== 0) {
      obj.totalCount = Math.round(message.totalCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCasesResponse>, I>>(base?: I): GetCasesResponse {
    return GetCasesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCasesResponse>, I>>(object: I): GetCasesResponse {
    const message = createBaseGetCasesResponse();
    message.cases = object.cases?.map((e) => Case.fromPartial(e)) || [];
    message.totalCount = object.totalCount ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
